import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, ChevronRight } from "lucide-react";

/**
 * Shared admin chrome — sticky top bar with title + logout button.
 * Extracted from AdminDashboard so every admin page can reuse it.
 */
export const AdminShell = ({ title, backTo = "/admin", children }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const doLogout = async () => {
        await logout();
        navigate("/admin/login");
    };

    return (
        <div className="min-h-screen bg-slate-100">
            <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
                <div className="max-w-4xl mx-auto px-3 sm:px-5 py-3 flex items-center justify-between gap-3">
                    <Link
                        to={backTo}
                        className="inline-flex items-center gap-2 text-slate-700"
                        data-testid="admin-back-btn"
                    >
                        <span className="grid place-items-center h-8 w-8 rounded-md bg-slate-100 text-slate-600">
                            <ChevronRight className="h-4 w-4 -scale-x-100" />
                        </span>
                        <span className="font-display font-bold text-lg tracking-tight text-slate-700">
                            {title}
                        </span>
                    </Link>
                    <button
                        onClick={doLogout}
                        data-testid="admin-logout-btn"
                        className="inline-flex items-center gap-2 px-3 py-2 rounded-md bg-red-500 text-white text-sm font-semibold hover:bg-red-600 transition-colors"
                    >
                        <LogOut className="h-4 w-4" /> Log Out
                    </button>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-3 sm:px-5 py-5">
                <div className="rounded-lg border-2 border-dashed border-emerald-300 bg-white p-4 sm:p-6">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default AdminShell;
